import { render } from "./AddBranchOffice.vue?vue&type=template&id=45dcdd94&scoped=true"
import script from "./AddBranchOffice.vue?vue&type=script&lang=js"
export * from "./AddBranchOffice.vue?vue&type=script&lang=js"

import "./AddBranchOffice.vue?vue&type=style&index=0&id=45dcdd94&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dcdd94"]])

export default __exports__